import { createContext, useContext, useState } from "react";

export const AppTabContext = createContext();

const AppTabContextProvider = ({ children }) => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleValueChain = () => {
    setValue("2");
  };

  return <AppTabContext.Provider value={{ value, handleChange, handleValueChain }}>{children}</AppTabContext.Provider>;
};

function useTabActive() {
  const context = useContext(AppTabContext);
  if (context === undefined) throw new Error("context not work");
  return context;
}

export { AppTabContextProvider, useTabActive };
